import { Checkbox, FormGroup, FormHelperText } from "@mui/material";
import FormControlLabel from "@mui/material/FormControlLabel";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { Field, getIn } from "formik";
import React from "react";

const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    checkbox: {
      padding: theme.spacing(0, 6, 0, 0),
    },
    checkboxLabelText: {
      fontSize: "16px",
      lineHeight: "24px",
      color: theme.gray800,
    },
    switch: {
      color: theme.gray500,
      marginLeft: 0,
      "& label": {
        alignSelf: "flex-start",
        marginLeft: 0,
        alignItems: "flex-start",
      },
    },
    error: { color: theme.red500 },
    labelWrapper: {
      display: "flex",
      flexDirection: "column",
    },
    label: {
      fontSize: "16px",
      fontWeight: "400",
      color: theme.gray800,
    },
    sublabel: {
      color: theme.gray500,
      fontSize: "14px",
    },
  }),
);
type CheckboxProps = {
  className?: string;
  disabled?: boolean;
  error?: boolean;
  helperText?: string;
  label?: React.ReactNode;
  sublabel?: string;
  name?: string;
  "data-test-id"?: string;
};

export function OLCheckbox({
  "data-test-id": dataTestId,
  ...props
}: CheckboxProps) {
  const classes = useStyles();

  return (
    <Field name={props.name}>
      {({ field, form, meta }: { field: any; form: any; meta: any }) => {
        const isError = !!(
          meta.error ||
          props.error ||
          getIn(form.status, field.name)
        );

        return (
          <FormGroup className={`${props.className} ${classes.switch}`}>
            <FormControlLabel
              {...field}
              {...props}
              className={`${classes.checkboxLabelText} ${
                isError ? classes.error : ""
              }`}
              control={
                <Checkbox
                  className={classes.checkbox}
                  checked={!!field.value}
                  color={"primary"}
                  disabled={props.disabled}
                  onChange={(e) => {
                    field.onChange(e);
                  }}
                  value={!!field.value}
                  data-test-id={dataTestId}
                />
              }
              label={
                <span className={classes.labelWrapper}>
                  <span className={classes.label}>{props.label}</span>
                  {props.sublabel && (
                    <span className={classes.sublabel}>{props.sublabel}</span>
                  )}
                </span>
              }
              name={props.name}
            />
            {props.helperText && (
              <FormHelperText className={isError ? classes.error : ""}>
                {props.helperText}
              </FormHelperText>
            )}
          </FormGroup>
        );
      }}
    </Field>
  );
}
